import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintDaftarKPRSubsidi = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocDaftarKPRSubsidi = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          DAFTAR DOKUMEN KPR BERSUBSIDI BTN
        </div>

        <div style={{ padding: "10px" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid #000",
                    padding: "8px 10px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  KELENGKAPAN DOKUMEN KPR BERSUBSIDI BTN
                </td>
              </tr>

              {/* A */}
              <tr>
                <td
                  style={{
                    width: "60px",
                    border: "1px solid #000",
                    padding: "6px 8px",
                    verticalAlign: "top",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  A
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 8px",
                    fontWeight: "bold",
                  }}
                >
                  Dokumen Pemohon
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi buku tabungan atas nama pemohon pada Bank BTN</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Formulir aplikasi kredit</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>3.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Pas foto terbaru</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>4.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat pemesanan rumah atau Resi KPR Elektronik</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>5.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi KTP Elektronik atau SSM KPR Elektronik</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>6.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi Kartu Keluarga</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>7.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi Akta Nikah atau akta perkawinan (bagi yang berstatus kawin) atau fotokopi akta cerai (bagi yang berstatus cerai)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>8.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi NPWP (khusus yang debitur dengan penghasilan telah menjadi wajib pajak ≥ 1 tahun)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>9.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>
                  Fotokopi bukti pelaporan pajak (khusus debitur dengan penghasilan telah menjadi wajib pajak ≥ 1 tahun dan penghasilan ≥ PTKP, melampirkan SPT PPh)
                  <br />• Telah menjadi wajib pajak ≥ 1 tahun dan penghasilan ≥ PTKP → melampirkan SPT PPh
                  <br />• Telah menjadi wajib pajak &lt; 1 tahun → melampirkan surat keterangan PTKP, melampirkan penyampaian SPT PPh tahun selanjutnya
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>10.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi rekening koran tabungan atau fotokopi buku tabungan yang disahkan oleh Bank (sekurang-kurangnya 3 bulan terakhir)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>11.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat keterangan bertempat tinggal dari kepala desa/lurah tempat tinggal saat ini (bilamana kelompok sasaran tidak bertempat tinggal sesuai alamat pada KTP Elektronik)</td>
              </tr>

              {/* B */}
              <tr>
                <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>B</td>
                <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Dokumen Penghasilan (Pemohon Pegawai)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Slip gaji yang disahkan oleh pejabat yang berwenang pada tempat bekerja</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat keterangan kepegawaian dari tempat bekerja</td>
              </tr>

              {/* C */}
              <tr>
                <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>C</td>
                <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Dokumen Khusus Pemohon Wiraswasta / Pekerja Mandiri</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat pernyataan penghasilan yang ditandatangani oleh pemohon dan diketahui oleh kepala desa/lurah</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Fotokopi dokumen perizinan usaha atau sekurang-kurangnya asli surat keterangan usaha dari kepala desa/lurah</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>3.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Catatan keuangan usaha, dan/atau rekening koran / fotokopi buku tabungan keuangan usaha</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>4.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Dokumen informasi usaha (foto, alamat, waktu operasional, denah lokasi / titik koordinat lokasi usaha)</td>
              </tr>

              {/* D SBUM */}
              <tr>
                <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>D</td>
                <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Dokumen Pemohon SBUM (Untuk KPR Bersubsidi BTN yang mendapatkan fasilitas SBUM)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat permohonan Subsidi Bantuan Uang Muka Perumahan (SBUM)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat pengakuan kekurangan bayar uang muka KPR Bersubsidi BTN</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pagebreak">
          <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
        </div>
        <div
          style={{
            paddingTop: "40px",
          }}
        >
          <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
            <tbody>
              {/* Pernyataan Debitur (D lagi di dokumen asli) */}
              <tr>
                <td style={{ border: "1px solid #000", padding: "6px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>D</td>
                <td style={{ border: "1px solid #000", padding: "6px 8px", fontWeight: "bold" }}>Surat Pernyataan Debitur</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>1.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat Pernyataan Tidak Bekerja yang diketahui oleh kepala desa/lurah (bilamana salah satu dari kelompok sasaran suami/istri tidak bekerja)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>2.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat Pernyataan KPR Bersubsidi BTN Format Internal Bank</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "right" }}>3.</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Surat Pernyataan KPR Bersubsidi BTN Format Kementerian PUPR</td>
              </tr>

              {/* E s/d I */}
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>E</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Surat Kuasa Pemohon</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>F</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Laporan Pemeriksaan Akhir (LPA)</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>G</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Surat Pernyataan Pemeriksaan Kelaikan Fungsi Bangunan Gedung</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>E</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Foto dokumentasi akad kredit pemohon KPR Bersubsidi BTN</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>I</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Berita Acara Serah Terima (BAST) Rumah Umum Tapak / Sarusun Umum</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", fontWeight: "bold", textAlign: "center" }}>J</td>
                <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold" }}>Foto dokumentasi stiker atau plat KPR Bersubsidi telah terpasang</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
